import { Component, OnInit } from '@angular/core';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';
import {JardinModel, ResponseJardinModel} from 'src/app/model/Jardin.model';

@Component({
  selector: 'app-mantenedor-ri',
  templateUrl: './mantenedor-ri.component.html',
  styleUrls: ['./mantenedor-ri.component.css']
})
export class MantenedorRIComponent implements OnInit {
  estadoSubida : string;
  parametroSubida:number =1;
  codigoJardinRBD:number;
  busquedaOK:boolean;
  dataJardin = new JardinModel();
  estado:number;
    respuesta : string;

  constructor(private api: apiService,) { }

  ngOnInit(): void {
    this.obtenerParametroRI()          
  }

  activar(){
    if (this.parametroSubida == 0){
      this.estado =1;
    }else{
        this.estado =0;
    }

    this.api.API_POST_cambiarParametroRI(this.estado).subscribe((response:any) => {

            this.respuesta = response.payload;
            if(this.respuesta ==='OK'){
              
                Swal.fire({
                  title: 'Activacion correcta',
                  text: "Se cambio el parametro.",
                  icon: "success",
                  confirmButtonText: 'OK'
                });
      
                    this.obtenerParametroRI(); 
            }

        
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cambiar parametro',
        text: 'Intentar nuevamente',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });
  }


  activarRIIndividual(){

        this.api.API_POST_activarRI(this.dataJardin.idJardinPeriodo).subscribe((response:any) => {

            this.respuesta = response.payload;
            if(this.respuesta ==='OK'){
              
                Swal.fire({
                  title: 'Activacion correcta',
                  text: "Se puede volver a subir el Reglamento Interno.",
                  icon: "success",
                  confirmButtonText: 'OK'
                });
      
                    this.obtenerParametroRI(); 
            }

        
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cambiar parametro',
        text: 'Intentar nuevamente',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });

  }


  obtenerParametroRI(){
    this.busquedaOK = false;
    this.api.API_GET_OtenerParametroRI().subscribe((response:any) => {
      this.parametroSubida = response.payload;
      if(this.parametroSubida == 0){
        this.estadoSubida = 'Multiples subidas'
      }else{
        this.estadoSubida = 'Unica subida'
      }
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cargar Jardín',
        text: 'Validar que el Código del jardín sea correcto.',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });
  }

 obtenerjardin(){
    this.api.API_POST_obtenerJardinPorRBD(this.codigoJardinRBD).subscribe((response:ResponseJardinModel) => {
      this.dataJardin = response.payload;
      this.busquedaOK = true;
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cargar Jardín',
        text: 'Validar que el Código del jardín sea correcto.',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });
  }
}
